export { default } from './chip'
export { default as DeprecatedChip } from './deprecated-chip'
